import React, { useEffect, useState } from "react";
import shallow from 'zustand/shallow';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getUserBaseUrl, getNavLinks } from "../utils";
import PrivateLayout from "./PrivateLayout";
import Loading from "./Loading/Loading";
import constants from "../utils/constants";
import { useUserStore } from "../stores";
const ROLES = constants().ROLES;
// const user = {
// name: "username", role: "admin", email: "somemail@gmail.com"
// }


const PrivateOutlet = (props) => {
  // const user = useAuth();
  // shallow will make render only once for the unknwon object in it
  const user = useUserStore((state) => state.data, shallow);
  const auth = useUserStore((state) => state.auth);
  const [checkAuth, setCheckAuth] = useState(false);
  const loading = useUserStore((state) => state.loading);
  const userLogin = useUserStore((state) => state.login);
  const userLogout = useUserStore((state) => state.logout);
  const location = useLocation();
  // const redirectUrl = location.state ? (location.state.url) : undefined;
  useEffect(() => {
    (async () => {
      try {
        const r = await fetch("/api/verify");
        if (r.status == 200) {
          const res = await r.json();
          userLogin(res.user);
          setCheckAuth(true);
        }
        else {
          userLogout();
          setCheckAuth(true);
        }
      } catch (error) {
        userLogout();
        setCheckAuth(true);
      }
    })();
  }, []);

  if (!checkAuth) {
    return <Loading />
  }
  if (checkAuth && !auth) {
    return <Navigate to={"/signin?url=" + location.pathname} />;
  }
  else if (checkAuth && auth && user) {
    console.log(user);
    return (
      <>
        <PrivateLayout user={user} navLinks={getNavLinks(user.role)}>
          <Outlet user={user} />
        </PrivateLayout>
      </>
    );
  }
};

export default PrivateOutlet;
